<template>
  <div>
    <div class="background">
      <span class="title"></span>&nbsp;
      <span class="tips">数据图表</span>
    </div>
    <div>
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="今年" name="first"></el-tab-pane>
        <el-tab-pane label="去年" name="second"></el-tab-pane>
        <el-button class="exportData" @click="exportData">导出数据</el-button>
      </el-tabs>
    </div>
    <div style="padding: 30px 28px 28px 28px">
      <div>
        <div id="order-care" :style="{ width: '100%', height: '400px' }"></div>
      </div>
    </div>
    <div class="background">
      <span class="title"></span>&nbsp;
      <span class="tips">数据报表</span>
    </div>
    <div style="margin-top: 20px">
      <el-table
        :data="tableData"
        border
        :header-cell-style="{ background: '#fafafa', fontWeight: 700 }"
        style="width: 100%"
      >
        <el-table-column prop="time" label="时间">
        </el-table-column>
        <el-table-column prop="memberCount" label="会员数">
        </el-table-column>
        <el-table-column prop="buyTotalCount" label="订单数">
        </el-table-column>
        <el-table-column label="成交金额">
          <template slot-scope="scope">
            {{ scope.row.buyTotalMoney.toFixed(2)}}
          </template>
        </el-table-column>
        <el-table-column label="客单价">
          <template slot-scope="scope">
            {{ scope.row.unitPrice.toFixed(2)}}
          </template>
        </el-table-column>
        <el-table-column label="会员数占比">
          <template slot-scope="scope">
            <el-progress :percentage="scope.row.memberCountRate"></el-progress>
          </template>
        </el-table-column>
        <el-table-column label="订单数占比">
          <template slot-scope="scope">
            <el-progress :percentage="scope.row.buyTotalRate"></el-progress>
          </template>
        </el-table-column>
        <el-table-column label="成交额占比">
          <template slot-scope="scope">
            <el-progress :percentage="scope.row.buyTotalMoneyRate"></el-progress>
          </template>
        </el-table-column>
      </el-table>
    </div>
        <!-- 生成报表 -->
        <generate :control = 'control'
                   v-if="control"
                    @transData="(val) => (control = val)"
                    @transData1 = 'getphone1'
                    ></generate>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import { periodBuyerCountone,exportDataOne } from "@/api/analysis/monthly-report";
import generate from '../../components/generate_report.vue'
export default {
  name: "monthly_report",
  data() {
    return {
      control:false,
      tableData: [],
      activeName: "first",
      zxData: {
        timeFlag: [],
        buyerCount: [],
        tradeCount: [],
        payment: [],
        buyerAvgCost: [],
      },
      yearRang: 0,
    };
  },
  components: {
    generate
  },
  computed: {
    ...mapState({
      changeColor: "globalBG",
    }),
  },
  mounted: function () {
    this.periodBuyerCount();
    this.$nextTick(() => {
      this.drawOrderCareBar();
      // window.addEventListener("resize", () => {
      //   this.myCharts.resize();
      // });
    });
  },
  methods: {
    // 导出数据
    async exportData() {
      this.control = true
    },
    getphone1(val){
      let postForm = JSON.parse(localStorage.getItem("oneMonth"))
      postForm.yearRange = this.yearRang
      postForm.exportRemark = val
      let paramStr = "";
      for (var key in postForm) {
        let temp = "&" + key + "=" + postForm[key];
        paramStr += temp;
      }
      paramStr = paramStr.substr(1);
      exportDataOne(paramStr).then((res)=>{
         if(res.code==1){
          this.control = true
         }else{
          this.$message.error(res.message);
         }
      })
    },
    handleClick(tab) {
      if (tab.name == "first") {
        this.yearRang = 0;
        this.periodBuyerCount();
      }
      if (tab.name == "second") {
        this.yearRang = 1;
        this.periodBuyerCount();
      }
    },
    async periodBuyerCount() {
      // let self = this;
      // yearRang 0 今年 1去年
      const res = await periodBuyerCountone({ yearRange: this.yearRang });
      this.tableData = res.data
      // .then((res) => {
      console.log(res, 2222);
      this.zxData.timeFlag = [];
      this.zxData.buyerCount = [];
      this.zxData.tradeCount = [];
      res.data.forEach((val, index) => {
        this.zxData.timeFlag.push(val.time); //时间段日期
        this.zxData.buyerCount.push(val.memberCount); //会员数
        this.zxData.tradeCount.push(val.buyTotalCount); //订单数
      });
      this.zxData.timeFlag = this.zxData.timeFlag.slice(0, this.zxData.timeFlag.length - 1)
      await this.drawOrderCareBar();
      // });
    },
    //绘制柱状图
    drawOrderCareBar() {
      let self = this;
      let orderCareBarChartOne = this.$echarts.init(
        document.getElementById("order-care"),
        "light"
      ); //初始化echats实例
      orderCareBarChartOne.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          barWidth: 20,
        },
        legend: { data: ["会员数", "订单数"] },
        xAxis: {
          // x轴
          type: "category",
          name: "时间",
          data: self.zxData.timeFlag,
        },
        yAxis: {
          // y轴
          type: "value",
          axisLine: {
            //y轴
            show: false,
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
          splitLine: {
            //网格线
            show: true,
            color: "#999",
          },
        },
        series: [
          {
            name: "会员数",
            data: self.zxData.buyerCount,
            type: "bar",
            smooth: true,
            color: ["#4CDFC0"],
            barWidth: 20,
          },
          {
            name: "订单数",
            data: self.zxData.tradeCount,
            type: "bar",
            smooth: true,
            color: ["#4878FF"],
            barWidth: 20,
          },
        ],
      });
      window.onresize = function () {
        orderCareBarChartOne.resize();
      };
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-progress-bar {
  padding-right: 70px;
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  margin-right: -76px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

/deep/.el-progress-bar__inner {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  background-color: #7e86ec;
  text-align: right;
  border-radius: 100px;
  line-height: 1;
  white-space: nowrap;
  -webkit-transition: width 0.6s ease;
  transition: width 0.6s ease;
}

.exportData {
  float: right;
}

.background {
  height: 32px;
  background: rgba(250, 250, 250, 1);
  opacity: 1;
  line-height: 32px;
  padding-left: 12px;
  margin: 6px 0 20px;
  .title {
    display: inline-block;
    width: 2px;
    height: 14px;
    background: rgba(254, 77, 69, 1);
    opacity: 1;
    border-radius: 3px;
    vertical-align: middle;
  }
  .tips {
    width: 56px;
    height: 20px;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    color: rgba(51, 51, 51, 1);
    opacity: 1;
    vertical-align: middle;
  }
}
.section-right-content-box {
  min-width: 1066px;
  margin: 10px 20px 0 20px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  opacity: 1;

  .echarts {
    width: 100%;
    height: 40px;
    background: #fafafa;
    opacity: 1;

    line-height: 40px;
  }
  .clos {
    width: 100%;
    height: 310px;
    background: #ffffff;
    border: 1px solid #f3f4f7;
    opacity: 1;
  }
}
</style>
